var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcActivity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "activity"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69119 3.40992C6.98331 3.40885 7.24211 3.59809 7.32965 3.87679L9.4996 10.7847L10.008 8.3826C10.0732 8.07443 10.3452 7.85397 10.6602 7.85397H13.3333C13.7015 7.85397 14 8.15244 14 8.52063C14 8.88882 13.7015 9.1873 13.3333 9.1873H11.2005L10.2777 13.5479C10.2149 13.8444 9.96008 14.0613 9.65737 14.0758C9.35466 14.0903 9.08024 13.8988 8.98942 13.6097L6.70187 6.32738L5.97081 8.71576C5.88504 8.99596 5.62636 9.1873 5.33333 9.1873H2.66667C2.29848 9.1873 2 8.88882 2 8.52063C2 8.15244 2.29848 7.85397 2.66667 7.85397H4.8402L6.05616 3.88145C6.14166 3.60212 6.39906 3.41099 6.69119 3.40992Z",
    fill: "#116584"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActivity);
export default __webpack_public_path__ + "static/media/ic-activity.24879f34a55092614a119c958190f3a9.svg";
export { ForwardRef as ReactComponent };